import { render, staticRenderFns } from "./StoryDetails.vue?vue&type=template&id=0c333939&"
import script from "./StoryDetails.vue?vue&type=script&lang=js&"
export * from "./StoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports